import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex, Point } from "honeycomb-grid";

import moment from "moment";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { Modal } from "react-bootstrap";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle, faShare, faRetweet, faSearch, faUndo } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

import { gapi } from "gapi-script";

const CLIENT_ID = "";
let ACCESS_TOKEN = "";

import { rgb } from "d3-color";
import { MAX_ARCS } from "containers/Home/reducer";

import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";

const GoogleDocsInner = (props) => {
  const { exportArray, fileName } = props;

  /*
	const dispatch = useDispatch();
	const history = useHistory();
	*/

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log(tokenResponse);
      ACCESS_TOKEN = tokenResponse?.access_token;

      handleExport();
    },
    onError: () => {
      console.log("Login Failed");
    }
  });

  const handleExport = () => {
    const conversation = exportArray ?? [];

    console.log("Export chat to google", conversation);

    let content = "";

    conversation
      .filter((c) => c?.isIgnoreExport !== true)
      .forEach((c) => {
        const retText = c?.userText || c?.text;
        content +=
          c?.user + "\n" + retText + "\n" + moment.utc(c?.date).local().format("MMMM Do YYYY, h:mm:ss a") + "\n\n";
      });

    const exportFile = new Blob([content], { type: "text/plain" });

    return fetch(`https://docs.googleapis.com/v1/documents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({ title: fileName })
    }).then((createResponse) =>
      createResponse.json().then((createResponseJson) => {
        console.log("what is createResponseJson", createResponseJson);

        window.open("https://docs.google.com/document/d/" + createResponseJson?.documentId);

        return fetch(`https://docs.googleapis.com/v1/documents/${createResponseJson?.documentId}:batchUpdate`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            //update this token with yours.
            Authorization: `Bearer ${ACCESS_TOKEN}`
          },
          body: JSON.stringify({
            requests: [
              {
                insertText: {
                  text: content,
                  location: { index: 1 }
                }
              }
            ]
          })
        }).then((insertResponse) =>
          insertResponse
            .json()
            .then((insertResponseJson) => console.log("what is insertResponseJson", insertResponseJson))
        );
      })
    );
  };

  return <Button onClick={() => login()}>{"Google Auth"}</Button>;
};

const GoogleDocsExport = (props) => {
  const { exportArray, fileName } = props;

  return (
    <GoogleOAuthProvider
      clientId={props?.googleClientId}
      onScriptLoadError={(error) => console.log("error auth google", error)}
    >
      <GoogleDocsInner exportArray={exportArray} fileName={fileName} />
    </GoogleOAuthProvider>
  );
};

export default GoogleDocsExport;

/*

export default class GoogleDocsExport extends React.PureComponent {
	constructor(props) {
		super(props);

		const initClient = () =>
			gapi.client.init({
				clientId: CLIENT_ID,
				scope: "https://www.googleapis.com/auth/drive",
			});

		gapi.load("client:auth2", initClient);

		this.state = {
			isGoogleLogin: false,
		};
	}

	timeout(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	handleExport() {
		const { exportArray, fileName } = this.props;

		const conversation = exportArray ?? [];

		console.log("Export chat to google", conversation);

		let content = "";

		conversation
			.filter((c) => c?.isIgnoreExport !== true)
			.forEach((c) => {
				const retText = c?.userText || c?.text;
				content +=
					c?.user +
					"\n" +
					retText +
					"\n" +
					moment
						.utc(c?.date)
						.local()
						.format("MMMM Do YYYY, h:mm:ss a") +
					"\n\n";
			});

		const exportFile = new Blob([content], { type: "text/plain" });
		console.log("what", exportArray, fileName, exportFile);

		return fetch(`https://www.googleapis.com/upload/drive/v3/files`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				//update this token with yours.
				Authorization: `Bearer ${ACCESS_TOKEN}`,
			},
			body: exportFile,
		}).then((r) => this.handleResponse(r));
	}

	handleResponse(response) {
		return response.json();
	}

	renderExport(bText = "Export to Google Docs") {
		const {
			isGoogleMode,
			isGoogleAuthed,
			updateIsGoogleAuthed,
		} = this.props;

		const { isGoogleLogin, isDashboardBuilding } = this.state;

		const onSuccess = (credentialResponse) => {
			ACCESS_TOKEN = credentialResponse?.credential;
			console.log("success!:", credentialResponse);

			this.handleExport();

			//updateIsGoogleAuthed(true);
		};
		const onFailure = (err) => {
			console.log("failed:", err);
		};

		return (
			<GoogleOAuthProvider clientId={CLIENT_ID}>
				<div
					style={{
						marginRight: "5px",
					}}
					className={isGoogleMode ? styles.googleModeSlides : ""}
				>
					{isGoogleLogin ? (
						<Button
							onClick={() => login()}
						>
							{"Google Auth"}
						</Button>
					) : (
						<div />
					)}
					{isDashboardBuilding ? (
						<LoadingIndicator style={{ margin: "0px" }} />
					) : (
						<Button
							onClick={() => {
								if (isGoogleAuthed === true) {
									this.handleExport();
								} else {
									this.setState({ isGoogleLogin: true });
								}
							}}
							type="primary"
						>
							{"Export"}
						</Button>
					)}
				</div>
			</GoogleOAuthProvider>
		);
	}

	render() {
		return <div>{this.renderExport()}</div>;
	}
}
*/
